export default (value) => {
  return /^[0-9]{4,6}$/.test(value)
}
